export var RendererHook;
(function (RendererHook) {
    RendererHook["INIT_CONTEXT"] = "initContext";
    RendererHook["INIT_CANVAS"] = "initCanvas";
})(RendererHook || (RendererHook = {}));
